// Icônes en SVG (traits de 24 px), sans dépendance externe.
const paths: Record<string, string> = {
  menu: "M4 6h16M4 12h16M4 18h16",
  back: "M15 18l-6-6 6-6",
  archive: "M3 7h18M5 7v12a1 1 0 001 1h12a1 1 0 001-1V7M9 11h6M4 4h16v3H4z",
  trash: "M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3",
  restore: "M3 12a9 9 0 109-9 9 9 0 00-6.4 2.6L3 8M3 3v5h5",
  star: "M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9z",
  unread: "M4 6h16v12H4zM4 7l8 6 8-6",
  folder: "M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z",
  inbox: "M3 13h5l2 3h4l2-3h5M5 5h14l2 8v6H3v-6z",
  at: "M16 12a4 4 0 11-1.2-2.8M16 8v5a2 2 0 004 0v-1a8 8 0 10-3.2 6.4",
  spam: "M12 3l9 16H3zM12 10v4M12 17h.01",
  settings: "M12 15a3 3 0 100-6 3 3 0 000 6zM19.4 15a1.7 1.7 0 00.3 1.8l.1.1a2 2 0 11-2.8 2.8l-.1-.1a1.7 1.7 0 00-1.8-.3 1.7 1.7 0 00-1 1.5V21a2 2 0 11-4 0v-.1a1.7 1.7 0 00-1.1-1.5 1.7 1.7 0 00-1.8.3l-.1.1a2 2 0 11-2.8-2.8l.1-.1a1.7 1.7 0 00.3-1.8 1.7 1.7 0 00-1.5-1H3a2 2 0 110-4h.1a1.7 1.7 0 001.5-1.1 1.7 1.7 0 00-.3-1.8l-.1-.1a2 2 0 112.8-2.8l.1.1a1.7 1.7 0 001.8.3H9a1.7 1.7 0 001-1.5V3a2 2 0 114 0v.1a1.7 1.7 0 001 1.5 1.7 1.7 0 001.8-.3l.1-.1a2 2 0 112.8 2.8l-.1.1a1.7 1.7 0 00-.3 1.8V9a1.7 1.7 0 001.5 1H21a2 2 0 110 4h-.1a1.7 1.7 0 00-1.5 1z",
  plus: "M12 5v14M5 12h14",
  move: "M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2zM12 10v6M9 13l3 3 3-3",
  clip: "M21 11l-8.5 8.5a5 5 0 01-7-7L14 4a3.5 3.5 0 015 5l-8.5 8.5a2 2 0 01-3-3L15 7",
  key: "M15 7a4 4 0 11-3.9 5H3v3h3v3h3v-3h2.1A4 4 0 0115 7z",
  forward: "M15 5l6 6-6 6M21 11H10a6 6 0 00-6 6v2",
  check: "M5 12l5 5L20 7",
  close: "M6 6l12 12M18 6L6 18",
  read: "M4 10l8-6 8 6v9H4zM4 10l8 5 8-5",
  reply: "M9 5L3 11l6 6M3 11h11a6 6 0 016 6v2",
  replyAll: "M12 5l-6 6 6 6M8 5l-6 6 6 6M6 11h9a6 6 0 016 6v2",
  pen: "M4 20h4L19 9l-4-4L4 16v4zM14 6l4 4",
  sent: "M22 2L11 13M22 2l-7 20-4-9-9-4z",
  draft: "M14 3H6a2 2 0 00-2 2v14a2 2 0 002 2h12a2 2 0 002-2V9zM14 3v6h6M8 13h8M8 17h5",
  bold: "M7 5h6a3.5 3.5 0 010 7H7zM7 12h7a3.5 3.5 0 010 7H7z",
  italic: "M10 5h8M6 19h8M14 5l-4 14",
  list: "M9 6h11M9 12h11M9 18h11M4 6h.01M4 12h.01M4 18h.01",
  numbered: "M10 6h10M10 12h10M10 18h10M4 4v4M3 18h3l-3 3h3M3 10h3",
  quote: "M7 7h3v6H6v-2a4 4 0 014-4M15 7h3v6h-4v-2a4 4 0 014-4",
  more: "M5 12a1 1 0 102 0 1 1 0 10-2 0M11 12a1 1 0 102 0 1 1 0 10-2 0M17 12a1 1 0 102 0 1 1 0 10-2 0",
  chevron: "M6 9l6 6 6-6",
  spark: "M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8zM19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z",
  stop: "M7 7h10v10H7z",
  search: "M11 18a7 7 0 100-14 7 7 0 000 14zM21 21l-5-5",
  copy: "M9 9h10v10H9zM5 15V5h10",
  shield: "M12 3l8 3v6c0 5-8 9-8 9s-8-4-8-9V6zM8 12l3 3 5-6",
  send: "M5 12h14M13 6l6 6-6 6",
  link: "M10 14a4 4 0 005.7 0l3-3a4 4 0 00-5.7-5.7l-1 1M14 10a4 4 0 00-5.7 0l-3 3a4 4 0 005.7 5.7l1-1",
};

export function Icon({ name, filled = false, size = 20 }: { name: keyof typeof paths | string; filled?: boolean; size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true"
      fill={filled ? "currentColor" : "none"} stroke="currentColor" stroke-width="1.8"
      stroke-linecap="round" stroke-linejoin="round">
      <path d={paths[name]} />
    </svg>
  );
}
